import { render, staticRenderFns } from "./TeachersRow.vue?vue&type=template&id=f726e270&"
import script from "./TeachersRow.vue?vue&type=script&lang=ts&"
export * from "./TeachersRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports